import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import attachmentsReducer from './attachments.slice';
import auctionPreviewReducer from './auctionPreview.slice';
import auctionsReducer from './auctions.slice';
import auctionsBidsReducer from './auctionsBids.slice';
import auctionsWatchReducer from './auctionsWatch.slice';
import buyerReducer from './buyer.slice';
import countersReducer from './counters.slice';
import myAuctionsReducer from './myAuctions.slice';
import tendersReducer from './tenders.slice';
import hamptonReducer from './hampton.slice';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const reducer = {
  router: routerReducer,
  counters: countersReducer,
  attachments: attachmentsReducer,
  auctions: auctionsReducer,
  auctionPreview: auctionPreviewReducer,
  myAuctions: myAuctionsReducer,
  buyer: buyerReducer,
  auctionsBids: auctionsBidsReducer,
  auctionsWatch: auctionsWatchReducer,
  tenders: tendersReducer,
  hampton: hamptonReducer,
};

export const store = configureStore({
  reducer,
  devTools: process.env.REACT_APP_ENV !== 'prod',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: process.env.REACT_APP_ENV !== 'prod',
      immutableCheck: process.env.REACT_APP_ENV !== 'prod',
    }).concat(routerMiddleware),
});

export function getActionsStack() {
  function lastAction(state = null, action: any) {
    return action;
  }
  // @ts-ignore
  store.replaceReducer(
    // @ts-ignore
    combineReducers({
      ...reducer,
      // @ts-ignore
      lastAction,
    }),
  );
  const actions: string[] = [];
  store.subscribe(() => {
    // @ts-ignore
    actions.push(store.getState().lastAction.type);
  });

  return {
    getActions: () => actions,
  };
}

export const history = { ...createReduxHistory(store) };

declare global {
  // Infer the `RootState` and `AppDispatch` types from the store itself
  type RootState = ReturnType<typeof store.getState>;
  // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
  type AppDispatch = typeof store.dispatch;
}
